import { ENDPOINTS } from './constants.js'

function timedFetch(url, ms = 8000) {
  const ctrl = new AbortController()
  const t = setTimeout(() => ctrl.abort(), ms)
  return fetch(url, { signal: ctrl.signal }).finally(() => clearTimeout(t))
}

export async function pingServer(server) {
  try {
    const res = await timedFetch(ENDPOINTS.ping(server.proxyBase))
    if (!res.ok) return null
    return await res.json()
  } catch { return null }
}

export async function getActiveSessions(server) {
  try {
    const res = await timedFetch(ENDPOINTS.active(server.proxyBase))
    if (!res.ok) return null
    return await res.json()
  } catch { return null }
}

export async function deploySession(server, number) {
  const ctrl = new AbortController()
  const t = setTimeout(() => ctrl.abort(), 15000)
  try {
    const res = await fetch(ENDPOINTS.deploy(server.proxyBase, number), { signal: ctrl.signal })
    if (!res.ok) {
      const body = await res.text().catch(() => '')
      throw new Error(`HTTP ${res.status}${body ? ': ' + body : ''}`)
    }
    return await res.json()
  } finally {
    clearTimeout(t)
  }
}

export async function healthCheckAll(servers) {
  return Promise.all(
    servers.map(async (server) => {
      const [ping, active] = await Promise.all([
        pingServer(server),
        getActiveSessions(server),
      ])
      return {
        server,
        status: (ping || active) ? 'online' : 'offline',
        ping,
        active,
        checkedAt: new Date(),
      }
    })
  )
}

export function pickHealthyServer(serverStats) {
  const healthy = serverStats.filter((s) => s.status === 'online')
  if (!healthy.length) return null
  return healthy[Math.floor(Math.random() * healthy.length)]
}
